export {default as Navb} from './navb'
export {default as Jumbo} from './jumbo'
export {default as Welcome} from './welcome';
export {default as Footer} from './footer';
export {default as Equipment} from './equipment';
export {default as Kit} from './kit';
export {default as Location} from './location';
export {default as Questions} from './questions';
export {default as Social} from './social';
